"use client"

import { Box, Button, Flex, Text } from "@chakra-ui/react"
import { useRouter } from "next/navigation"

export default function PreviewBanner() {
  const { refresh } = useRouter()

  const exitPreview = async () => {
    try {
      await fetch("/api/exit-preview")
      refresh()
    } catch (error) {
      console.error("Error exiting preview mode:", error)
    }
  }

  return (
    <Box
      bg="orange.500"
      boxShadow="md"
      color="white"
      left={0}
      position="fixed"
      px={4}
      py={2}
      right={0}
      top={0}
      zIndex={9999}
    >
      <Flex
        align="center"
        justify="space-between"
        maxW="container.xl"
        mx="auto"
      >
        <Text fontSize="sm" fontWeight="medium">
          🔍 Preview Mode - You are viewing draft content
        </Text>
        <Button
          colorPalette="whiteAlpha"
          onClick={exitPreview}
          size="sm"
          variant="outline"
        >
          Exit Preview
        </Button>
      </Flex>
    </Box>
  )
}
